// components/ImageSlider.js

import React from "react";
import {
  IoMdArrowDropleftCircle,
  IoMdArrowDroprightCircle,
} from "react-icons/io";
import { ImCancelCircle } from "react-icons/im";

function ImageSlider({
  images,
  currentImageIndex,
  onClose,
  setCurrentImageIndex,
}) {
  const goToPrevious = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const goToNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <button className="absolute top-5 right-44 text-white" onClick={onClose}>
        <ImCancelCircle className="w-10 h-10" />
      </button>
      <button className="absolute left-14 text-white" onClick={goToPrevious}>
        <IoMdArrowDropleftCircle className="w-10 h-10" />
      </button>
      <button className="absolute right-14 text-white" onClick={goToNext}>
        <IoMdArrowDroprightCircle className="w-10 h-10" />
      </button>
      <img
        src={images[currentImageIndex]}
        alt={`Slide ${currentImageIndex}`}
        className="max-w-full max-h-full"
      />
    </div>
  );
}

export default ImageSlider;
